import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/gameTab.css';
// import {getText} from '../../../../helpers/localization';
import {ASSETS_URL} from '../../../../constants/endpoints';
import {calculateTimeDifference, formatTimeInSecondsToMMSS} from '../../../../helpers/helperFunctions';

// actions
import {selectGame} from '../../../../actions/gamesActions';

// components
import Counter from './counter';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        openBetsList: state.vpp.openBetsList,
        games: state.vpp.games
    };
};

class GameTab extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            openBetsList: storeData.vpp.openBetsList,
            games: storeData.vpp.games,
            timeLeft: calculateTimeDifference(new Date(), this._getNextEventTime()) / 1000
        };
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: calculateTimeDifference(new Date(), this._getNextEventTime()) / 1000
        });
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                openBetsList: storeData.vpp.openBetsList,
                games: storeData.vpp.games
            });
        }
    }

    _clickTab(index) {
        if (this.props.store) {
            this.props.store.dispatch(selectGame(index, this.props.store));
        }
    }

    _getNextEventTime() {
        let eventTime = new Date();
        let event;
        if (this.state && this.state.nextEventsTimeStamp) {
            event = this.state.nextEventsTimeStamp.find((evt) => evt.channel === this.props.game.channel);
            if (event) {
                eventTime = Number(event.eventTime);
            }
        }

        return eventTime;
    }

    _generateCounterUI() {
        let store = this.props.store;
        let storeData = store.getState();
        let games = storeData.vpp.games;
        let counterUI;
        if (games && games.length && this.state.openBetsList && this.state.openBetsList.length) {
            let gameChannel = storeData.vpp.games[this.props.gameindex].channel;
            let gameOpenBets = this.state.openBetsList.filter((oBet) => oBet.game.channel === gameChannel);

            if (gameOpenBets && gameOpenBets.length) {
                counterUI = (<Counter count={gameOpenBets.length} wrapperStyle={style.counterWrapperStyle}
                                      htmlId={'counter_' + gameChannel}/>);
            }
        }
        return counterUI;
    }

    render() {
        let blinkingColor = () => {
            let timeLeft = Math.floor(this.state.timeLeft);
            if (timeLeft < 0) {
                return '';
            } else if (timeLeft <= 20) {
                return style.blinkingRed;
            } else if (timeLeft <= 40) {
                return style.blinkingAmber;
            } else {
                return '';
            }
        };
        let isTimeToShowSuccess = !!this.state.games[this.props.gameindex].betsCommitted;
        let isTimeToShowError = !!this.state.games[this.props.gameindex].betsFailedBeingCommitted;

        let openBetCounterUI = this._generateCounterUI();

        return (<div className={`${style.gameTab} ${this.state.selectedGameIndex === this.props.gameindex
            ? style.selected
            : ''}`} onClick={() => this._clickTab(this.props.gameindex)} id={'gameTab_' + this.props.gameindex}>
            {
                /* insert a transparent overlay over the tab div for the blinking behaviour */
                blinkingColor() !== ''
                    ? <div className={`${style.blinkingOverlay} ${blinkingColor()}`}/>
                    : ''
            }
            {
                isTimeToShowSuccess
                    ? <div className={style.successNotificationContainer}>
                        <div className={style.iconContainer}>
                            <div className={style.checkmarkContainer}>
                                <div className={style.checkmark}/>
                            </div>
                        </div>
                    </div>
                    : ''
            }
            {
                isTimeToShowError
                    ? <div className={style.successNotificationContainer}>
                        <div className={style.iconContainer}>
                            <div className={style.errormarkContainer}>
                                <div className={style.errormark}/>
                            </div>
                        </div>
                    </div>
                    : ''
            }
            {/* {
        isTimeToShowSuccess
          ? <div className={style.successNotificationContainer}><img className={style.successNotification} src={`${ASSETS_URL}miscellaneous/success.svg`} alt='success'/></div>
          : ''
      } */
            }
            {/* <div className={style.gameName}>
          <div className={style.gameNameText}>{getText(this.props.game.name, this.props.store)}</div>
        </div> */
            }
            <div className={style.iconContainer}>
                <img src={`${ASSETS_URL}${this.props.game.URL.BMS_ASSETS}/tabIcon.svg`} className={style.icon}
                     alt='success'/>
            </div>
            <div className={style.timer}>{formatTimeInSecondsToMMSS(this.state.timeLeft)}</div>
            {openBetCounterUI}
        </div>);
    }
}

export default connect(mapStateToProps)(GameTab);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/sharedComponents/components/gameTab.js